import React, {
  useEffect,
  useRef,
} from "react";

export default function NextScenesConfirmDialog({
  open = false,
  title = "",
  message = "",
  stayLabel = "Stay",
  leaveLabel = "Leave",
  onStay,
  onLeave,
}) {
  const stayRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    stayRef.current?.focus?.();

    function onKeyDown(event) {
      if (event.key === "Escape") {
        event.preventDefault();
        onStay?.();
      }
    }

    window.addEventListener(
      "keydown",
      onKeyDown
    );

    return () => {
      window.removeEventListener(
        "keydown",
        onKeyDown
      );
    };
  }, [open, onStay]);

  if (!open) {
    return null;
  }

  return (
    <div
      role="presentation"
      onMouseDown={(event) => {
        if (
          event.target ===
          event.currentTarget
        ) {
          onStay?.();
        }
      }}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1200,
        display: "grid",
        placeItems: "center",
        padding: 20,
        background:
          "rgba(15,23,42,0.56)",
      }}
    >
      <section
        className="ns-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="nextscenes-confirm-title"
        style={{
          width: "min(520px, 100%)",
          padding:
            "clamp(20px, 4vw, 28px)",
          borderRadius: 20,
          border:
            "1.5px solid rgba(5,150,105,0.28)",
          boxShadow:
            "0 24px 70px rgba(15,23,42,0.28)",
          background: "#fff",
        }}
      >
        <div
          style={{
            fontSize: 11,
            fontWeight: 900,
            letterSpacing: "0.11em",
            textTransform: "uppercase",
            color: "#047857",
          }}
        >
          NextScenes
        </div>

        <h3
          id="nextscenes-confirm-title"
          className="ns-card-title"
          style={{
            margin: "7px 0 8px",
            fontSize: 22,
            lineHeight: 1.25,
          }}
        >
          {title}
        </h3>

        <p
          className="ns-card-meta"
          style={{
            margin: 0,
            lineHeight: 1.6,
          }}
        >
          {message}
        </p>

        <div
          style={{
            marginTop: 22,
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          <button
            ref={stayRef}
            className="ns-button ns-button-outline"
            type="button"
            onClick={onStay}
          >
            {stayLabel}
          </button>

          <button
            className="ns-button ns-button-primary"
            type="button"
            onClick={onLeave}
          >
            {leaveLabel}
          </button>
        </div>
      </section>
    </div>
  );
}
